// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:400,500,700);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  margin: 0 auto;
  max-width: 1280px;
  width: 90%;
}

@media only screen and (min-width : 601px) {
  .container {
    width: 85%;
  }
}
@media only screen and (min-width : 993px) {
  .container {
    width: 70%;
  }
}
.col .row {
  margin-left: -0.75rem;
  margin-right: -0.75rem;
}

.section {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.section.no-pad {
  padding: 0;
}
.section.no-pad-bot {
  padding-bottom: 0;
}
.section.no-pad-top {
  padding-top: 0;
}

.row {
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 20px;
}
.row:after {
  content: "";
  display: table;
  clear: both;
}
.row .col {
  float: left;
  box-sizing: border-box;
  padding: 0 0.75rem;
  min-height: 1px;
}
.row .col[class*=push-], .row .col[class*=pull-] {
  position: relative;
}
.row .col.s1 {
  width: 8.3333333333%;
  margin-left: auto;
  left: auto;
  right: auto;
}
.row .col.s2 {
  width: 16.6666666667%;
  margin-left: auto;
  left: auto;
  right: auto;
}
.row .col.s3 {
  width: 25%;
  margin-left: auto;
  left: auto;
  right: auto;
}
.row .col.s4 {
  width: 33.3333333333%;
  margin-left: auto;
  left: auto;
  right: auto;
}
.row .col.s5 {
  width: 41.6666666667%;
  margin-left: auto;
  left: auto;
  right: auto;
}
.row .col.s6 {
  width: 50%;
  margin-left: auto;
  left: auto;
  right: auto;
}
.row .col.s7 {
  width: 58.3333333333%;
  margin-left: auto;
  left: auto;
  right: auto;
}
.row .col.s8 {
  width: 66.6666666667%;
  margin-left: auto;
  left: auto;
  right: auto;
}
.row .col.s9 {
  width: 75%;
  margin-left: auto;
  left: auto;
  right: auto;
}
.row .col.s10 {
  width: 83.3333333333%;
  margin-left: auto;
  left: auto;
  right: auto;
}
.row .col.s11 {
  width: 91.6666666667%;
  margin-left: auto;
  left: auto;
  right: auto;
}
.row .col.s12 {
  width: 100%;
  margin-left: auto;
  left: auto;
  right: auto;
}
.row .col.offset-s1 {
  margin-left: 8.3333333333%;
}
.row .col.pull-s1 {
  right: 8.3333333333%;
}
.row .col.push-s1 {
  left: 8.3333333333%;
}
.row .col.offset-s2 {
  margin-left: 16.6666666667%;
}
.row .col.pull-s2 {
  right: 16.6666666667%;
}
.row .col.push-s2 {
  left: 16.6666666667%;
}
.row .col.offset-s3 {
  margin-left: 25%;
}
.row .col.pull-s3 {
  right: 25%;
}
.row .col.push-s3 {
  left: 25%;
}
.row .col.offset-s4 {
  margin-left: 33.3333333333%;
}
.row .col.pull-s4 {
  right: 33.3333333333%;
}
.row .col.push-s4 {
  left: 33.3333333333%;
}
.row .col.offset-s5 {
  margin-left: 41.6666666667%;
}
.row .col.pull-s5 {
  right: 41.6666666667%;
}
.row .col.push-s5 {
  left: 41.6666666667%;
}
.row .col.offset-s6 {
  margin-left: 50%;
}
.row .col.pull-s6 {
  right: 50%;
}
.row .col.push-s6 {
  left: 50%;
}
.row .col.offset-s7 {
  margin-left: 58.3333333333%;
}
.row .col.pull-s7 {
  right: 58.3333333333%;
}
.row .col.push-s7 {
  left: 58.3333333333%;
}
.row .col.offset-s8 {
  margin-left: 66.6666666667%;
}
.row .col.pull-s8 {
  right: 66.6666666667%;
}
.row .col.push-s8 {
  left: 66.6666666667%;
}
.row .col.offset-s9 {
  margin-left: 75%;
}
.row .col.pull-s9 {
  right: 75%;
}
.row .col.push-s9 {
  left: 75%;
}
.row .col.offset-s10 {
  margin-left: 83.3333333333%;
}
.row .col.pull-s10 {
  right: 83.3333333333%;
}
.row .col.push-s10 {
  left: 83.3333333333%;
}
.row .col.offset-s11 {
  margin-left: 91.6666666667%;
}
.row .col.pull-s11 {
  right: 91.6666666667%;
}
.row .col.push-s11 {
  left: 91.6666666667%;
}
.row .col.offset-s12 {
  margin-left: 100%;
}
.row .col.pull-s12 {
  right: 100%;
}
.row .col.push-s12 {
  left: 100%;
}
@media only screen and (min-width : 601px) {
  .row .col.m1 {
    width: 8.3333333333%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.m2 {
    width: 16.6666666667%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.m3 {
    width: 25%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.m4 {
    width: 33.3333333333%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.m5 {
    width: 41.6666666667%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.m6 {
    width: 50%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.m7 {
    width: 58.3333333333%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.m8 {
    width: 66.6666666667%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.m9 {
    width: 75%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.m10 {
    width: 83.3333333333%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.m11 {
    width: 91.6666666667%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.m12 {
    width: 100%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.offset-m1 {
    margin-left: 8.3333333333%;
  }
  .row .col.pull-m1 {
    right: 8.3333333333%;
  }
  .row .col.push-m1 {
    left: 8.3333333333%;
  }
  .row .col.offset-m2 {
    margin-left: 16.6666666667%;
  }
  .row .col.pull-m2 {
    right: 16.6666666667%;
  }
  .row .col.push-m2 {
    left: 16.6666666667%;
  }
  .row .col.offset-m3 {
    margin-left: 25%;
  }
  .row .col.pull-m3 {
    right: 25%;
  }
  .row .col.push-m3 {
    left: 25%;
  }
  .row .col.offset-m4 {
    margin-left: 33.3333333333%;
  }
  .row .col.pull-m4 {
    right: 33.3333333333%;
  }
  .row .col.push-m4 {
    left: 33.3333333333%;
  }
  .row .col.offset-m5 {
    margin-left: 41.6666666667%;
  }
  .row .col.pull-m5 {
    right: 41.6666666667%;
  }
  .row .col.push-m5 {
    left: 41.6666666667%;
  }
  .row .col.offset-m6 {
    margin-left: 50%;
  }
  .row .col.pull-m6 {
    right: 50%;
  }
  .row .col.push-m6 {
    left: 50%;
  }
  .row .col.offset-m7 {
    margin-left: 58.3333333333%;
  }
  .row .col.pull-m7 {
    right: 58.3333333333%;
  }
  .row .col.push-m7 {
    left: 58.3333333333%;
  }
  .row .col.offset-m8 {
    margin-left: 66.6666666667%;
  }
  .row .col.pull-m8 {
    right: 66.6666666667%;
  }
  .row .col.push-m8 {
    left: 66.6666666667%;
  }
  .row .col.offset-m9 {
    margin-left: 75%;
  }
  .row .col.pull-m9 {
    right: 75%;
  }
  .row .col.push-m9 {
    left: 75%;
  }
  .row .col.offset-m10 {
    margin-left: 83.3333333333%;
  }
  .row .col.pull-m10 {
    right: 83.3333333333%;
  }
  .row .col.push-m10 {
    left: 83.3333333333%;
  }
  .row .col.offset-m11 {
    margin-left: 91.6666666667%;
  }
  .row .col.pull-m11 {
    right: 91.6666666667%;
  }
  .row .col.push-m11 {
    left: 91.6666666667%;
  }
  .row .col.offset-m12 {
    margin-left: 100%;
  }
  .row .col.pull-m12 {
    right: 100%;
  }
  .row .col.push-m12 {
    left: 100%;
  }
}
@media only screen and (min-width : 993px) {
  .row .col.l1 {
    width: 8.3333333333%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.l2 {
    width: 16.6666666667%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.l3 {
    width: 25%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.l4 {
    width: 33.3333333333%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.l5 {
    width: 41.6666666667%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.l6 {
    width: 50%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.l7 {
    width: 58.3333333333%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.l8 {
    width: 66.6666666667%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.l9 {
    width: 75%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.l10 {
    width: 83.3333333333%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.l11 {
    width: 91.6666666667%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.l12 {
    width: 100%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.offset-l1 {
    margin-left: 8.3333333333%;
  }
  .row .col.pull-l1 {
    right: 8.3333333333%;
  }
  .row .col.push-l1 {
    left: 8.3333333333%;
  }
  .row .col.offset-l2 {
    margin-left: 16.6666666667%;
  }
  .row .col.pull-l2 {
    right: 16.6666666667%;
  }
  .row .col.push-l2 {
    left: 16.6666666667%;
  }
  .row .col.offset-l3 {
    margin-left: 25%;
  }
  .row .col.pull-l3 {
    right: 25%;
  }
  .row .col.push-l3 {
    left: 25%;
  }
  .row .col.offset-l4 {
    margin-left: 33.3333333333%;
  }
  .row .col.pull-l4 {
    right: 33.3333333333%;
  }
  .row .col.push-l4 {
    left: 33.3333333333%;
  }
  .row .col.offset-l5 {
    margin-left: 41.6666666667%;
  }
  .row .col.pull-l5 {
    right: 41.6666666667%;
  }
  .row .col.push-l5 {
    left: 41.6666666667%;
  }
  .row .col.offset-l6 {
    margin-left: 50%;
  }
  .row .col.pull-l6 {
    right: 50%;
  }
  .row .col.push-l6 {
    left: 50%;
  }
  .row .col.offset-l7 {
    margin-left: 58.3333333333%;
  }
  .row .col.pull-l7 {
    right: 58.3333333333%;
  }
  .row .col.push-l7 {
    left: 58.3333333333%;
  }
  .row .col.offset-l8 {
    margin-left: 66.6666666667%;
  }
  .row .col.pull-l8 {
    right: 66.6666666667%;
  }
  .row .col.push-l8 {
    left: 66.6666666667%;
  }
  .row .col.offset-l9 {
    margin-left: 75%;
  }
  .row .col.pull-l9 {
    right: 75%;
  }
  .row .col.push-l9 {
    left: 75%;
  }
  .row .col.offset-l10 {
    margin-left: 83.3333333333%;
  }
  .row .col.pull-l10 {
    right: 83.3333333333%;
  }
  .row .col.push-l10 {
    left: 83.3333333333%;
  }
  .row .col.offset-l11 {
    margin-left: 91.6666666667%;
  }
  .row .col.pull-l11 {
    right: 91.6666666667%;
  }
  .row .col.push-l11 {
    left: 91.6666666667%;
  }
  .row .col.offset-l12 {
    margin-left: 100%;
  }
  .row .col.pull-l12 {
    right: 100%;
  }
  .row .col.push-l12 {
    left: 100%;
  }
}
@media only screen and (min-width : 1201px) {
  .row .col.xl1 {
    width: 8.3333333333%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.xl2 {
    width: 16.6666666667%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.xl3 {
    width: 25%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.xl4 {
    width: 33.3333333333%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.xl5 {
    width: 41.6666666667%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.xl6 {
    width: 50%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.xl7 {
    width: 58.3333333333%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.xl8 {
    width: 66.6666666667%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.xl9 {
    width: 75%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.xl10 {
    width: 83.3333333333%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.xl11 {
    width: 91.6666666667%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.xl12 {
    width: 100%;
    margin-left: auto;
    left: auto;
    right: auto;
  }
  .row .col.offset-xl1 {
    margin-left: 8.3333333333%;
  }
  .row .col.pull-xl1 {
    right: 8.3333333333%;
  }
  .row .col.push-xl1 {
    left: 8.3333333333%;
  }
  .row .col.offset-xl2 {
    margin-left: 16.6666666667%;
  }
  .row .col.pull-xl2 {
    right: 16.6666666667%;
  }
  .row .col.push-xl2 {
    left: 16.6666666667%;
  }
  .row .col.offset-xl3 {
    margin-left: 25%;
  }
  .row .col.pull-xl3 {
    right: 25%;
  }
  .row .col.push-xl3 {
    left: 25%;
  }
  .row .col.offset-xl4 {
    margin-left: 33.3333333333%;
  }
  .row .col.pull-xl4 {
    right: 33.3333333333%;
  }
  .row .col.push-xl4 {
    left: 33.3333333333%;
  }
  .row .col.offset-xl5 {
    margin-left: 41.6666666667%;
  }
  .row .col.pull-xl5 {
    right: 41.6666666667%;
  }
  .row .col.push-xl5 {
    left: 41.6666666667%;
  }
  .row .col.offset-xl6 {
    margin-left: 50%;
  }
  .row .col.pull-xl6 {
    right: 50%;
  }
  .row .col.push-xl6 {
    left: 50%;
  }
  .row .col.offset-xl7 {
    margin-left: 58.3333333333%;
  }
  .row .col.pull-xl7 {
    right: 58.3333333333%;
  }
  .row .col.push-xl7 {
    left: 58.3333333333%;
  }
  .row .col.offset-xl8 {
    margin-left: 66.6666666667%;
  }
  .row .col.pull-xl8 {
    right: 66.6666666667%;
  }
  .row .col.push-xl8 {
    left: 66.6666666667%;
  }
  .row .col.offset-xl9 {
    margin-left: 75%;
  }
  .row .col.pull-xl9 {
    right: 75%;
  }
  .row .col.push-xl9 {
    left: 75%;
  }
  .row .col.offset-xl10 {
    margin-left: 83.3333333333%;
  }
  .row .col.pull-xl10 {
    right: 83.3333333333%;
  }
  .row .col.push-xl10 {
    left: 83.3333333333%;
  }
  .row .col.offset-xl11 {
    margin-left: 91.6666666667%;
  }
  .row .col.pull-xl11 {
    right: 91.6666666667%;
  }
  .row .col.push-xl11 {
    left: 91.6666666667%;
  }
  .row .col.offset-xl12 {
    margin-left: 100%;
  }
  .row .col.pull-xl12 {
    right: 100%;
  }
  .row .col.push-xl12 {
    left: 100%;
  }
}

html {
  font-family: "Roboto", sans-serif;
  font-size: 15px;
}

html, body {
  min-height: 100vh;
  margin: 0px;
}

/* Weird ng-component fix */
ng-component {
  width: 100%;
  background-color: #FFFFFF;
}

/* iFrame fix for adal iframe */
iframe {
  border: 0 !important;
}

.fill-remaining-space {
  flex: 1 1 auto;
}

.flex-1 {
  flex: 1 !important;
}

.flex-2 {
  flex: 2 !important;
}

.flex-3 {
  flex: 3 !important;
}

.flex-4 {
  flex: 4 !important;
}

.flex-5 {
  flex: 5 !important;
}

.flex-6 {
  flex: 6 !important;
}

.flex-7 {
  flex: 7 !important;
}

.flex-8 {
  flex: 8 !important;
}

.w-25 {
  width: 25% !important;
}

.h-25 {
  height: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.h-50 {
  height: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.h-75 {
  height: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.h-100 {
  height: 100% !important;
}

.mt-0 {
  margin-top: 0px !important;
}

.mb-0 {
  margin-bottom: 0px !important;
}

.mr-0 {
  margin-right: 0px !important;
}

.ml-0 {
  margin-left: 0px !important;
}

.m-0 {
  margin: 0px !important;
}

.pt-0 {
  padding-top: 0px !important;
}

.pb-0 {
  padding-bottom: 0px !important;
}

.pr-0 {
  padding-right: 0px !important;
}

.pl-0 {
  padding-left: 0px !important;
}

.p-0 {
  padding: 0px !important;
}

.mt-5 {
  margin-top: 5px !important;
}

.mb-5 {
  margin-bottom: 5px !important;
}

.mr-5 {
  margin-right: 5px !important;
}

.ml-5 {
  margin-left: 5px !important;
}

.m-5 {
  margin: 5px !important;
}

.pt-5 {
  padding-top: 5px !important;
}

.pb-5 {
  padding-bottom: 5px !important;
}

.pr-5 {
  padding-right: 5px !important;
}

.pl-5 {
  padding-left: 5px !important;
}

.p-5 {
  padding: 5px !important;
}

.mt-10 {
  margin-top: 10px !important;
}

.mb-10 {
  margin-bottom: 10px !important;
}

.mr-10 {
  margin-right: 10px !important;
}

.ml-10 {
  margin-left: 10px !important;
}

.m-10 {
  margin: 10px !important;
}

.pt-10 {
  padding-top: 10px !important;
}

.pb-10 {
  padding-bottom: 10px !important;
}

.pr-10 {
  padding-right: 10px !important;
}

.pl-10 {
  padding-left: 10px !important;
}

.p-10 {
  padding: 10px !important;
}

.mt-15 {
  margin-top: 15px !important;
}

.mb-15 {
  margin-bottom: 15px !important;
}

.mr-15 {
  margin-right: 15px !important;
}

.ml-15 {
  margin-left: 15px !important;
}

.m-15 {
  margin: 15px !important;
}

.pt-15 {
  padding-top: 15px !important;
}

.pb-15 {
  padding-bottom: 15px !important;
}

.pr-15 {
  padding-right: 15px !important;
}

.pl-15 {
  padding-left: 15px !important;
}

.p-15 {
  padding: 15px !important;
}

.mt-20 {
  margin-top: 20px !important;
}

.mb-20 {
  margin-bottom: 20px !important;
}

.mr-20 {
  margin-right: 20px !important;
}

.ml-20 {
  margin-left: 20px !important;
}

.m-20 {
  margin: 20px !important;
}

.pt-20 {
  padding-top: 20px !important;
}

.pb-20 {
  padding-bottom: 20px !important;
}

.pr-20 {
  padding-right: 20px !important;
}

.pl-20 {
  padding-left: 20px !important;
}

.p-20 {
  padding: 20px !important;
}

.mt-25 {
  margin-top: 25px !important;
}

.mb-25 {
  margin-bottom: 25px !important;
}

.mr-25 {
  margin-right: 25px !important;
}

.ml-25 {
  margin-left: 25px !important;
}

.m-25 {
  margin: 25px !important;
}

.pt-25 {
  padding-top: 25px !important;
}

.pb-25 {
  padding-bottom: 25px !important;
}

.pr-25 {
  padding-right: 25px !important;
}

.pl-25 {
  padding-left: 25px !important;
}

.p-25 {
  padding: 25px !important;
}

.mt-30 {
  margin-top: 30px !important;
}

.mb-30 {
  margin-bottom: 30px !important;
}

.mr-30 {
  margin-right: 30px !important;
}

.ml-30 {
  margin-left: 30px !important;
}

.m-30 {
  margin: 30px !important;
}

.pt-30 {
  padding-top: 30px !important;
}

.pb-30 {
  padding-bottom: 30px !important;
}

.pr-30 {
  padding-right: 30px !important;
}

.pl-30 {
  padding-left: 30px !important;
}

.p-30 {
  padding: 30px !important;
}

.mt-35 {
  margin-top: 35px !important;
}

.mb-35 {
  margin-bottom: 35px !important;
}

.mr-35 {
  margin-right: 35px !important;
}

.ml-35 {
  margin-left: 35px !important;
}

.m-35 {
  margin: 35px !important;
}

.pt-35 {
  padding-top: 35px !important;
}

.pb-35 {
  padding-bottom: 35px !important;
}

.pr-35 {
  padding-right: 35px !important;
}

.pl-35 {
  padding-left: 35px !important;
}

.p-35 {
  padding: 35px !important;
}

.mt-40 {
  margin-top: 40px !important;
}

.mb-40 {
  margin-bottom: 40px !important;
}

.mr-40 {
  margin-right: 40px !important;
}

.ml-40 {
  margin-left: 40px !important;
}

.m-40 {
  margin: 40px !important;
}

.pt-40 {
  padding-top: 40px !important;
}

.pb-40 {
  padding-bottom: 40px !important;
}

.pr-40 {
  padding-right: 40px !important;
}

.pl-40 {
  padding-left: 40px !important;
}

.p-40 {
  padding: 40px !important;
}

.mt-45 {
  margin-top: 45px !important;
}

.mb-45 {
  margin-bottom: 45px !important;
}

.mr-45 {
  margin-right: 45px !important;
}

.ml-45 {
  margin-left: 45px !important;
}

.m-45 {
  margin: 45px !important;
}

.pt-45 {
  padding-top: 45px !important;
}

.pb-45 {
  padding-bottom: 45px !important;
}

.pr-45 {
  padding-right: 45px !important;
}

.pl-45 {
  padding-left: 45px !important;
}

.p-45 {
  padding: 45px !important;
}

.mt-50 {
  margin-top: 50px !important;
}

.mb-50 {
  margin-bottom: 50px !important;
}

.mr-50 {
  margin-right: 50px !important;
}

.ml-50 {
  margin-left: 50px !important;
}

.m-50 {
  margin: 50px !important;
}

.pt-50 {
  padding-top: 50px !important;
}

.pb-50 {
  padding-bottom: 50px !important;
}

.pr-50 {
  padding-right: 50px !important;
}

.pl-50 {
  padding-left: 50px !important;
}

.p-50 {
  padding: 50px !important;
}

/*******************
  Utility Classes
*******************/
.border-box {
  box-sizing: border-box;
}

.center, .center-align {
  text-align: center;
}

.text-right {
  text-align: right;
}

.left {
  float: left !important;
}

.right {
  float: right !important;
}

.pointer {
  cursor: pointer;
}

.position-inherit {
  position: inherit !important;
}

.min-height-inherit {
  min-height: inherit !important;
}

.hover:hover {
  background-color: #3C3C41;
}

.space-between {
  justify-content: space-between;
}

.block {
  display: block;
}

.flex {
  display: flex;
}

.flex-center {
  justify-content: center;
  align-items: center;
}

.flex-column {
  flex-direction: column;
}

.noselect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

/*******************
  Custom Classes
*******************/
.mat-mdc-dialog-container {
  --mat-dialog-container-shape: 4px;
}
.mat-mdc-dialog-container .mat-mdc-dialog-surface {
  display: block;
  box-sizing: border-box;
  padding: 24px;
  overflow: auto;
}

.mat-mdc-chip {
  --mat-chip-container-height: 27px;
  --mat-chip-container-shape-radius: 0;
  --mat-chip-outline-width: 0;
  --mat-chip-label-text-size: 14px;
  --mat-chip-label-text-weight: 500;
  display: inline-flex;
  vertical-align: middle;
  padding: 0;
}
.mat-mdc-chip .mdc-evolution-chip__action {
  padding: 0 5px;
}

.mat-chip-active,
.mat-chip-inactive {
  --mat-chip-label-text-color: #FFFFFF;
  --mat-chip-selected-label-text-color: #FFFFFF;
}

.mat-chip-active {
  --mat-chip-elevated-container-color: #00C853;
  --mat-chip-elevated-selected-container-color: #00C853;
  background-color: #00C853 !important;
}

.mat-chip-inactive {
  --mat-chip-elevated-container-color: #FF375F;
  --mat-chip-elevated-selected-container-color: #FF375F;
  background-color: #FF375F !important;
}

footer {
  height: 100px;
  background-color: #FFFFFF;
  text-align: center;
}
footer span {
  color: #3C3C41;
  font-size: 14px;
}
footer a {
  text-decoration: none;
}
footer li {
  display: inline-block;
  padding-right: 10px;
}
footer li:first-child span {
  border-left-style: none;
}
footer li span {
  color: #3C3C41;
  border-left-color: base-color(20-dark-gray);
  border-left-style: solid;
  border-left-width: 1px;
  padding-left: 5px;
  line-height: 15px;
}
footer li a {
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/assets/sass/_grid.scss","webpack://./src/shared/components/footer/footer.component.scss","webpack://./src/assets/sass/core.scss"],"names":[],"mappings":"AACA;EACI,cAAA;EACA,iBAAA;EACA,UAAA;ACCJ;;ADCA;EACI;IACI,UAAA;ECEN;AACF;ADAA;EACI;IACI,UAAA;ECEN;AACF;ADAA;EACI,qBAAA;EACA,sBAAA;ACEJ;;ADCA;EACI,iBAAA;EACA,oBAAA;ACEJ;ADAI;EACI,UAAA;ACER;ADAI;EACI,iBAAA;ACER;ADAI;EACI,cAAA;ACER;;ADoBA;EACI,iBAAA;EACA,kBAAA;EACA,mBAAA;ACjBJ;ADoBI;EACI,WAAA;EACA,cAAA;EACA,WAAA;AClBR;ADqBI;EACI,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;ACnBR;ADqBQ;EAEI,kBAAA;ACpBZ;AD2BY;EACI,oBAFG;EA1Cf,iBAAA;EACA,UAAA;EACA,WAAA;ACoBJ;ADqBY;EACI,qBAFG;EA1Cf,iBAAA;EACA,UAAA;EACA,WAAA;AC0BJ;ADeY;EACI,UAFG;EA1Cf,iBAAA;EACA,UAAA;EACA,WAAA;ACgCJ;ADSY;EACI,qBAFG;EA1Cf,iBAAA;EACA,UAAA;EACA,WAAA;ACsCJ;ADGY;EACI,qBAFG;EA1Cf,iBAAA;EACA,UAAA;EACA,WAAA;AC4CJ;ADHY;EACI,UAFG;EA1Cf,iBAAA;EACA,UAAA;EACA,WAAA;ACkDJ;ADTY;EACI,qBAFG;EA1Cf,iBAAA;EACA,UAAA;EACA,WAAA;ACwDJ;ADfY;EACI,qBAFG;EA1Cf,iBAAA;EACA,UAAA;EACA,WAAA;AC8DJ;ADrBY;EACI,UAFG;EA1Cf,iBAAA;EACA,UAAA;EACA,WAAA;ACoEJ;AD3BY;EACI,qBAFG;EA1Cf,iBAAA;EACA,UAAA;EACA,WAAA;AC0EJ;ADjCY;EACI,qBAFG;EA1Cf,iBAAA;EACA,UAAA;EACA,WAAA;ACgFJ;ADvCY;EACI,WAFG;EA1Cf,iBAAA;EACA,UAAA;EACA,WAAA;ACsFJ;ADnFI;EACI,0BA+CW;ACsCnB;ADnFI;EACI,oBA4CW;ACyCnB;ADnFI;EACI,mBAyCW;AC4CnB;AD5FI;EACI,2BA+CW;AC+CnB;AD5FI;EACI,qBA4CW;ACkDnB;AD5FI;EACI,oBAyCW;ACqDnB;ADrGI;EACI,gBA+CW;ACwDnB;ADrGI;EACI,UA4CW;AC2DnB;ADrGI;EACI,SAyCW;AC8DnB;AD9GI;EACI,2BA+CW;ACiEnB;AD9GI;EACI,qBA4CW;ACoEnB;AD9GI;EACI,oBAyCW;ACuEnB;ADvHI;EACI,2BA+CW;AC0EnB;ADvHI;EACI,qBA4CW;AC6EnB;ADvHI;EACI,oBAyCW;ACgFnB;ADhII;EACI,gBA+CW;ACmFnB;ADhII;EACI,UA4CW;ACsFnB;ADhII;EACI,SAyCW;ACyFnB;ADzII;EACI,2BA+CW;AC4FnB;ADzII;EACI,qBA4CW;AC+FnB;ADzII;EACI,oBAyCW;ACkGnB;ADlJI;EACI,2BA+CW;ACqGnB;ADlJI;EACI,qBA4CW;ACwGnB;ADlJI;EACI,oBAyCW;AC2GnB;AD3JI;EACI,gBA+CW;AC8GnB;AD3JI;EACI,UA4CW;ACiHnB;AD3JI;EACI,SAyCW;ACoHnB;ADpKI;EACI,2BA+CW;ACuHnB;ADpKI;EACI,qBA4CW;AC0HnB;ADpKI;EACI,oBAyCW;AC6HnB;AD7KI;EACI,2BA+CW;ACgInB;AD7KI;EACI,qBA4CW;ACmInB;AD7KI;EACI,oBAyCW;ACsInB;ADtLI;EACI,iBA+CW;ACyInB;ADtLI;EACI,WA4CW;AC4InB;ADtLI;EACI,UAyCW;AC+InB;AD1IQ;EAKQ;IACI,oBAFG;IA9DnB,iBAAA;IACA,UAAA;IACA,WAAA;ECyMF;ED5Ic;IACI,qBAFG;IA9DnB,iBAAA;IACA,UAAA;IACA,WAAA;EC+MF;EDlJc;IACI,UAFG;IA9DnB,iBAAA;IACA,UAAA;IACA,WAAA;ECqNF;EDxJc;IACI,qBAFG;IA9DnB,iBAAA;IACA,UAAA;IACA,WAAA;EC2NF;ED9Jc;IACI,qBAFG;IA9DnB,iBAAA;IACA,UAAA;IACA,WAAA;ECiOF;EDpKc;IACI,UAFG;IA9DnB,iBAAA;IACA,UAAA;IACA,WAAA;ECuOF;ED1Kc;IACI,qBAFG;IA9DnB,iBAAA;IACA,UAAA;IACA,WAAA;EC6OF;EDhLc;IACI,qBAFG;IA9DnB,iBAAA;IACA,UAAA;IACA,WAAA;ECmPF;EDtLc;IACI,UAFG;IA9DnB,iBAAA;IACA,UAAA;IACA,WAAA;ECyPF;ED5Lc;IACI,qBAFG;IA9DnB,iBAAA;IACA,UAAA;IACA,WAAA;EC+PF;EDlMc;IACI,qBAFG;IA9DnB,iBAAA;IACA,UAAA;IACA,WAAA;ECqQF;EDxMc;IACI,WAFG;IA9DnB,iBAAA;IACA,UAAA;IACA,WAAA;EC2QF;EDxQE;IACI,0BAmEe;ECuMrB;EDxQE;IACI,oBAgEe;EC0MrB;EDxQE;IACI,mBA6De;EC6MrB;EDjRE;IACI,2BAmEe;ECgNrB;EDjRE;IACI,qBAgEe;ECmNrB;EDjRE;IACI,oBA6De;ECsNrB;ED1RE;IACI,gBAmEe;ECyNrB;ED1RE;IACI,UAgEe;EC4NrB;ED1RE;IACI,SA6De;EC+NrB;EDnSE;IACI,2BAmEe;ECkOrB;EDnSE;IACI,qBAgEe;ECqOrB;EDnSE;IACI,oBA6De;ECwOrB;ED5SE;IACI,2BAmEe;EC2OrB;ED5SE;IACI,qBAgEe;EC8OrB;ED5SE;IACI,oBA6De;ECiPrB;EDrTE;IACI,gBAmEe;ECoPrB;EDrTE;IACI,UAgEe;ECuPrB;EDrTE;IACI,SA6De;EC0PrB;ED9TE;IACI,2BAmEe;EC6PrB;ED9TE;IACI,qBAgEe;ECgQrB;ED9TE;IACI,oBA6De;ECmQrB;EDvUE;IACI,2BAmEe;ECsQrB;EDvUE;IACI,qBAgEe;ECyQrB;EDvUE;IACI,oBA6De;EC4QrB;EDhVE;IACI,gBAmEe;EC+QrB;EDhVE;IACI,UAgEe;ECkRrB;EDhVE;IACI,SA6De;ECqRrB;EDzVE;IACI,2BAmEe;ECwRrB;EDzVE;IACI,qBAgEe;EC2RrB;EDzVE;IACI,oBA6De;EC8RrB;EDlWE;IACI,2BAmEe;ECiSrB;EDlWE;IACI,qBAgEe;ECoSrB;EDlWE;IACI,oBA6De;ECuSrB;ED3WE;IACI,iBAmEe;EC0SrB;ED3WE;IACI,WAgEe;EC6SrB;ED3WE;IACI,UA6De;ECgTrB;AACF;AD3SQ;EAKQ;IACI,oBAFG;IAnFnB,iBAAA;IACA,UAAA;IACA,WAAA;EC+XF;ED7Sc;IACI,qBAFG;IAnFnB,iBAAA;IACA,UAAA;IACA,WAAA;ECqYF;EDnTc;IACI,UAFG;IAnFnB,iBAAA;IACA,UAAA;IACA,WAAA;EC2YF;EDzTc;IACI,qBAFG;IAnFnB,iBAAA;IACA,UAAA;IACA,WAAA;ECiZF;ED/Tc;IACI,qBAFG;IAnFnB,iBAAA;IACA,UAAA;IACA,WAAA;ECuZF;EDrUc;IACI,UAFG;IAnFnB,iBAAA;IACA,UAAA;IACA,WAAA;EC6ZF;ED3Uc;IACI,qBAFG;IAnFnB,iBAAA;IACA,UAAA;IACA,WAAA;ECmaF;EDjVc;IACI,qBAFG;IAnFnB,iBAAA;IACA,UAAA;IACA,WAAA;ECyaF;EDvVc;IACI,UAFG;IAnFnB,iBAAA;IACA,UAAA;IACA,WAAA;EC+aF;ED7Vc;IACI,qBAFG;IAnFnB,iBAAA;IACA,UAAA;IACA,WAAA;ECqbF;EDnWc;IACI,qBAFG;IAnFnB,iBAAA;IACA,UAAA;IACA,WAAA;EC2bF;EDzWc;IACI,WAFG;IAnFnB,iBAAA;IACA,UAAA;IACA,WAAA;ECicF;ED9bE;IACI,0BAwFe;ECwWrB;ED9bE;IACI,oBAqFe;EC2WrB;ED9bE;IACI,mBAkFe;EC8WrB;EDvcE;IACI,2BAwFe;ECiXrB;EDvcE;IACI,qBAqFe;ECoXrB;EDvcE;IACI,oBAkFe;ECuXrB;EDhdE;IACI,gBAwFe;EC0XrB;EDhdE;IACI,UAqFe;EC6XrB;EDhdE;IACI,SAkFe;ECgYrB;EDzdE;IACI,2BAwFe;ECmYrB;EDzdE;IACI,qBAqFe;ECsYrB;EDzdE;IACI,oBAkFe;ECyYrB;EDleE;IACI,2BAwFe;EC4YrB;EDleE;IACI,qBAqFe;EC+YrB;EDleE;IACI,oBAkFe;ECkZrB;ED3eE;IACI,gBAwFe;ECqZrB;ED3eE;IACI,UAqFe;ECwZrB;ED3eE;IACI,SAkFe;EC2ZrB;EDpfE;IACI,2BAwFe;EC8ZrB;EDpfE;IACI,qBAqFe;ECiarB;EDpfE;IACI,oBAkFe;ECoarB;ED7fE;IACI,2BAwFe;ECuarB;ED7fE;IACI,qBAqFe;EC0arB;ED7fE;IACI,oBAkFe;EC6arB;EDtgBE;IACI,gBAwFe;ECgbrB;EDtgBE;IACI,UAqFe;ECmbrB;EDtgBE;IACI,SAkFe;ECsbrB;ED/gBE;IACI,2BAwFe;ECybrB;ED/gBE;IACI,qBAqFe;EC4brB;ED/gBE;IACI,oBAkFe;EC+brB;EDxhBE;IACI,2BAwFe;ECkcrB;EDxhBE;IACI,qBAqFe;ECqcrB;EDxhBE;IACI,oBAkFe;ECwcrB;EDjiBE;IACI,iBAwFe;EC2crB;EDjiBE;IACI,WAqFe;EC8crB;EDjiBE;IACI,UAkFe;ECidrB;AACF;AD5cQ;EAKQ;IACI,oBAFG;IAxGnB,iBAAA;IACA,UAAA;IACA,WAAA;ECqjBF;ED9cc;IACI,qBAFG;IAxGnB,iBAAA;IACA,UAAA;IACA,WAAA;EC2jBF;EDpdc;IACI,UAFG;IAxGnB,iBAAA;IACA,UAAA;IACA,WAAA;ECikBF;ED1dc;IACI,qBAFG;IAxGnB,iBAAA;IACA,UAAA;IACA,WAAA;ECukBF;EDhec;IACI,qBAFG;IAxGnB,iBAAA;IACA,UAAA;IACA,WAAA;EC6kBF;EDtec;IACI,UAFG;IAxGnB,iBAAA;IACA,UAAA;IACA,WAAA;ECmlBF;ED5ec;IACI,qBAFG;IAxGnB,iBAAA;IACA,UAAA;IACA,WAAA;ECylBF;EDlfc;IACI,qBAFG;IAxGnB,iBAAA;IACA,UAAA;IACA,WAAA;EC+lBF;EDxfc;IACI,UAFG;IAxGnB,iBAAA;IACA,UAAA;IACA,WAAA;ECqmBF;ED9fc;IACI,qBAFG;IAxGnB,iBAAA;IACA,UAAA;IACA,WAAA;EC2mBF;EDpgBc;IACI,qBAFG;IAxGnB,iBAAA;IACA,UAAA;IACA,WAAA;ECinBF;ED1gBc;IACI,WAFG;IAxGnB,iBAAA;IACA,UAAA;IACA,WAAA;ECunBF;EDpnBE;IACI,0BA6Ge;ECygBrB;EDpnBE;IACI,oBA0Ge;EC4gBrB;EDpnBE;IACI,mBAuGe;EC+gBrB;ED7nBE;IACI,2BA6Ge;ECkhBrB;ED7nBE;IACI,qBA0Ge;ECqhBrB;ED7nBE;IACI,oBAuGe;ECwhBrB;EDtoBE;IACI,gBA6Ge;EC2hBrB;EDtoBE;IACI,UA0Ge;EC8hBrB;EDtoBE;IACI,SAuGe;ECiiBrB;ED/oBE;IACI,2BA6Ge;ECoiBrB;ED/oBE;IACI,qBA0Ge;ECuiBrB;ED/oBE;IACI,oBAuGe;EC0iBrB;EDxpBE;IACI,2BA6Ge;EC6iBrB;EDxpBE;IACI,qBA0Ge;ECgjBrB;EDxpBE;IACI,oBAuGe;ECmjBrB;EDjqBE;IACI,gBA6Ge;ECsjBrB;EDjqBE;IACI,UA0Ge;ECyjBrB;EDjqBE;IACI,SAuGe;EC4jBrB;ED1qBE;IACI,2BA6Ge;EC+jBrB;ED1qBE;IACI,qBA0Ge;ECkkBrB;ED1qBE;IACI,oBAuGe;ECqkBrB;EDnrBE;IACI,2BA6Ge;ECwkBrB;EDnrBE;IACI,qBA0Ge;EC2kBrB;EDnrBE;IACI,oBAuGe;EC8kBrB;ED5rBE;IACI,gBA6Ge;ECilBrB;ED5rBE;IACI,UA0Ge;EColBrB;ED5rBE;IACI,SAuGe;ECulBrB;EDrsBE;IACI,2BA6Ge;EC0lBrB;EDrsBE;IACI,qBA0Ge;EC6lBrB;EDrsBE;IACI,oBAuGe;ECgmBrB;ED9sBE;IACI,2BA6Ge;ECmmBrB;ED9sBE;IACI,qBA0Ge;ECsmBrB;ED9sBE;IACI,oBAuGe;ECymBrB;EDvtBE;IACI,iBA6Ge;EC4mBrB;EDvtBE;IACI,WA0Ge;EC+mBrB;EDvtBE;IACI,UAuGe;ECknBrB;AACF;;ACvwBA;EACI,iCAAA;EACA,eAAA;AD0wBJ;;ACvwBA;EACI,iBAAA;EACA,WAAA;AD0wBJ;;ACvwBA,2BAAA;AACA;EACI,WAAA;EACA,yBAAA;AD0wBJ;;ACvwBA,+BAAA;AACA;EACI,oBAAA;AD0wBJ;;ACvwBA;EACI,cAAA;AD0wBJ;;ACtwBI;EACI,kBAAA;ADywBR;;AC1wBI;EACI,kBAAA;AD6wBR;;AC9wBI;EACI,kBAAA;ADixBR;;AClxBI;EACI,kBAAA;ADqxBR;;ACtxBI;EACI,kBAAA;ADyxBR;;AC1xBI;EACI,kBAAA;AD6xBR;;AC9xBI;EACI,kBAAA;ADiyBR;;AClyBI;EACI,kBAAA;ADqyBR;;AC/xBI;EACI,qBAAA;ADkyBR;;AChyBI;EACI,sBAAA;ADmyBR;;ACvyBI;EACI,qBAAA;AD0yBR;;ACxyBI;EACI,sBAAA;AD2yBR;;AC/yBI;EACI,qBAAA;ADkzBR;;AChzBI;EACI,sBAAA;ADmzBR;;ACvzBI;EACI,sBAAA;AD0zBR;;ACxzBI;EACI,uBAAA;AD2zBR;;ACpzBI;EACI,0BAHA;AD0zBR;;ACpzBI;EACI,6BAPA;AD8zBR;;ACpzBI;EACI,4BAXA;ADk0BR;;ACpzBI;EACI,2BAfA;ADs0BR;;ACpzBI;EACI,sBAnBA;AD00BR;;ACpzBI;EACI,2BAvBA;AD80BR;;ACpzBI;EACI,8BA3BA;ADk1BR;;ACpzBI;EACI,6BA/BA;ADs1BR;;ACpzBI;EACI,4BAnCA;AD01BR;;ACpzBI;EACI,uBAvCA;AD81BR;;AC51BI;EACI,0BAHA;ADk2BR;;AC51BI;EACI,6BAPA;ADs2BR;;AC51BI;EACI,4BAXA;AD02BR;;AC51BI;EACI,2BAfA;AD82BR;;AC51BI;EACI,sBAnBA;ADk3BR;;AC51BI;EACI,2BAvBA;ADs3BR;;AC51BI;EACI,8BA3BA;AD03BR;;AC51BI;EACI,6BA/BA;AD83BR;;AC51BI;EACI,4BAnCA;ADk4BR;;AC51BI;EACI,uBAvCA;ADs4BR;;ACp4BI;EACI,2BAHA;AD04BR;;ACp4BI;EACI,8BAPA;AD84BR;;ACp4BI;EACI,6BAXA;ADk5BR;;ACp4BI;EACI,4BAfA;ADs5BR;;ACp4BI;EACI,uBAnBA;AD05BR;;ACp4BI;EACI,4BAvBA;AD85BR;;ACp4BI;EACI,+BA3BA;ADk6BR;;ACp4BI;EACI,8BA/BA;ADs6BR;;ACp4BI;EACI,6BAnCA;AD06BR;;ACp4BI;EACI,wBAvCA;AD86BR;;AC56BI;EACI,2BAHA;ADk7BR;;AC56BI;EACI,8BAPA;ADs7BR;;AC56BI;EACI,6BAXA;AD07BR;;AC56BI;EACI,4BAfA;AD87BR;;AC56BI;EACI,uBAnBA;ADk8BR;;AC56BI;EACI,4BAvBA;ADs8BR;;AC56BI;EACI,+BA3BA;AD08BR;;AC56BI;EACI,8BA/BA;AD88BR;;AC56BI;EACI,6BAnCA;ADk9BR;;AC56BI;EACI,wBAvCA;ADs9BR;;ACp9BI;EACI,2BAHA;AD09BR;;ACp9BI;EACI,8BAPA;AD89BR;;ACp9BI;EACI,6BAXA;ADk+BR;;ACp9BI;EACI,4BAfA;ADs+BR;;ACp9BI;EACI,uBAnBA;AD0+BR;;ACp9BI;EACI,4BAvBA;AD8+BR;;ACp9BI;EACI,+BA3BA;ADk/BR;;ACp9BI;EACI,8BA/BA;ADs/BR;;ACp9BI;EACI,6BAnCA;AD0/BR;;ACp9BI;EACI,wBAvCA;AD8/BR;;AC5/BI;EACI,2BAHA;ADkgCR;;AC5/BI;EACI,8BAPA;ADsgCR;;AC5/BI;EACI,6BAXA;AD0gCR;;AC5/BI;EACI,4BAfA;AD8gCR;;AC5/BI;EACI,uBAnBA;ADkhCR;;AC5/BI;EACI,4BAvBA;ADshCR;;AC5/BI;EACI,+BA3BA;AD0hCR;;AC5/BI;EACI,8BA/BA;AD8hCR;;AC5/BI;EACI,6BAnCA;ADkiCR;;AC5/BI;EACI,wBAvCA;ADsiCR;;ACpiCI;EACI,2BAHA;AD0iCR;;ACpiCI;EACI,8BAPA;AD8iCR;;ACpiCI;EACI,6BAXA;ADkjCR;;ACpiCI;EACI,4BAfA;ADsjCR;;ACpiCI;EACI,uBAnBA;AD0jCR;;ACpiCI;EACI,4BAvBA;AD8jCR;;ACpiCI;EACI,+BA3BA;ADkkCR;;ACpiCI;EACI,8BA/BA;ADskCR;;ACpiCI;EACI,6BAnCA;AD0kCR;;ACpiCI;EACI,wBAvCA;AD8kCR;;AC5kCI;EACI,2BAHA;ADklCR;;AC5kCI;EACI,8BAPA;ADslCR;;AC5kCI;EACI,6BAXA;AD0lCR;;AC5kCI;EACI,4BAfA;AD8lCR;;AC5kCI;EACI,uBAnBA;ADkmCR;;AC5kCI;EACI,4BAvBA;ADsmCR;;AC5kCI;EACI,+BA3BA;AD0mCR;;AC5kCI;EACI,8BA/BA;AD8mCR;;AC5kCI;EACI,6BAnCA;ADknCR;;AC5kCI;EACI,wBAvCA;ADsnCR;;ACpnCI;EACI,2BAHA;AD0nCR;;ACpnCI;EACI,8BAPA;AD8nCR;;ACpnCI;EACI,6BAXA;ADkoCR;;ACpnCI;EACI,4BAfA;ADsoCR;;ACpnCI;EACI,uBAnBA;AD0oCR;;ACpnCI;EACI,4BAvBA;AD8oCR;;ACpnCI;EACI,+BA3BA;ADkpCR;;ACpnCI;EACI,8BA/BA;ADspCR;;ACpnCI;EACI,6BAnCA;AD0pCR;;ACpnCI;EACI,wBAvCA;AD8pCR;;AC5pCI;EACI,2BAHA;ADkqCR;;AC5pCI;EACI,8BAPA;ADsqCR;;AC5pCI;EACI,6BAXA;AD0qCR;;AC5pCI;EACI,4BAfA;AD8qCR;;AC5pCI;EACI,uBAnBA;ADkrCR;;AC5pCI;EACI,4BAvBA;ADsrCR;;AC5pCI;EACI,+BA3BA;AD0rCR;;AC5pCI;EACI,8BA/BA;AD8rCR;;AC5pCI;EACI,6BAnCA;ADksCR;;AC5pCI;EACI,wBAvCA;ADssCR;;ACpsCI;EACI,2BAHA;AD0sCR;;ACpsCI;EACI,8BAPA;AD8sCR;;ACpsCI;EACI,6BAXA;ADktCR;;ACpsCI;EACI,4BAfA;ADstCR;;ACpsCI;EACI,uBAnBA;AD0tCR;;ACpsCI;EACI,4BAvBA;AD8tCR;;ACpsCI;EACI,+BA3BA;ADkuCR;;ACpsCI;EACI,8BA/BA;ADsuCR;;ACpsCI;EACI,6BAnCA;AD0uCR;;ACpsCI;EACI,wBAvCA;AD8uCR;;ACnsCA;;mBAAA;AAIA;EACI,sBAAA;ADqsCJ;;AClsCA;EACI,kBAAA;ADqsCJ;;AClsCA;EACI,iBAAA;ADqsCJ;;AClsCA;EACI,sBAAA;ADqsCJ;;AClsCA;EACI,uBAAA;ADqsCJ;;AClsCA;EACI,eAAA;ADqsCJ;;AClsCA;EACI,4BAAA;ADqsCJ;;AClsCA;EACI,8BAAA;ADqsCJ;;AClsCA;EACI,yBAAA;ADqsCJ;;AClsCA;EACI,8BAAA;ADqsCJ;;AClsCA;EACI,cAAA;ADqsCJ;;AClsCA;EACI,aAAA;ADqsCJ;;AClsCA;EACI,uBAAA;EACA,mBAAA;ADqsCJ;;AClsCA;EACI,sBAAA;ADqsCJ;;AClsCA;EACI,2BAAA;EACA,yBAAA;EAIA,iBAAA;ADqsCJ;;AClsCA;;mBAAA;AAKA;EACI,iCAAA;ADmsCJ;ACjsCI;EACI,cAAA;EACA,sBAAA;EACA,aAAA;EACA,cAAA;ADmsCR;;AC9rCA;EACI,iCAAA;EACA,oCAAA;EACA,2BAAA;EACA,gCAAA;EACA,iCAAA;EACA,oBAAA;EACA,sBAAA;EACA,UAAA;ADisCJ;AC9rCI;EACI,cAAA;ADgsCR;;AC5rCA;;EAEI,oCAAA;EACA,6CAAA;AD+rCJ;;AC5rCA;EACI,4CAAA;EACA,qDAAA;EACA,oCAAA;AD+rCJ;;AC5rCA;EACI,4CAAA;EACA,qDAAA;EACA,oCAAA;AD+rCJ;;AA34CA;EACI,aAAA;EACA,yBAAA;EACA,kBAAA;AA84CJ;AA54CI;EACI,cAAA;EACA,eAAA;AA84CR;AA34CI;EACI,qBAAA;AA64CR;AA14CI;EACI,qBAAA;EACA,mBAAA;AA44CR;AAz4CY;EACI,uBAAA;AA24ChB;AAv4CQ;EACI,cAAA;EACA,2CAAA;EACA,wBAAA;EACA,sBAAA;EACA,iBAAA;EACA,iBAAA;AAy4CZ;AAv4CQ;EACI,qBAAA;AAy4CZ","sourcesContent":["@use 'sass:math';\n.container {\n    margin: 0 auto;\n    max-width: 1280px;\n    width: 90%;\n}\n@media #{$medium-and-up} {\n    .container {\n        width: 85%;\n    }\n}\n@media #{$large-and-up} {\n    .container {\n        width: 70%;\n    }\n}\n.col .row {\n    margin-left: (-1 * math.div($gutter-width, 2));\n    margin-right: (-1 * math.div($gutter-width, 2));\n}\n\n.section {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n\n    &.no-pad {\n        padding: 0;\n    }\n    &.no-pad-bot {\n        padding-bottom: 0;\n    }\n    &.no-pad-top {\n        padding-top: 0;\n    }\n}\n\n// Mixins to eliminate code repitition\n@mixin reset-offset {\n    margin-left: auto;\n    left: auto;\n    right: auto;\n}\n@mixin grid-classes($size, $i, $perc) {\n    &.offset-#{$size}#{$i} {\n        margin-left: $perc;\n    }\n    &.pull-#{$size}#{$i} {\n        right: $perc;\n    }\n    &.push-#{$size}#{$i} {\n        left: $perc;\n    }\n}\n\n.row {\n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom: 20px;\n\n    // Clear floating children\n    &:after {\n        content: \"\";\n        display: table;\n        clear: both;\n    }\n\n    .col {\n        float: left;\n        box-sizing: border-box;\n        padding: 0 math.div($gutter-width, 2);\n        min-height: 1px;\n\n        &[class*=\"push-\"],\n        &[class*=\"pull-\"] {\n            position: relative;\n        }\n\n        $i: 1;\n        @while $i <= $num-cols {\n            $devidedval: math.div($num-cols, $i);\n            $perc: unquote(math.div(100, $devidedval) + \"%\");\n            &.s#{$i} {\n                width: $perc;\n                @include reset-offset;\n            }\n            $i: $i + 1;\n        }\n\n        $i: 1;\n        @while $i <= $num-cols {\n            $devidedval: math.div($num-cols, $i);\n            $perc: unquote(math.div(100, $devidedval) + \"%\");\n            @include grid-classes(\"s\", $i, $perc);\n            $i: $i + 1;\n        }\n\n        @media #{$medium-and-up} {\n            $i: 1;\n            @while $i <= $num-cols {\n                $devidedval: math.div($num-cols, $i);\n                $perc: unquote(math.div(100, $devidedval) + \"%\");\n                &.m#{$i} {\n                    width: $perc;\n                    @include reset-offset;\n                }\n                $i: $i + 1;\n            }\n\n            $i: 1;\n            @while $i <= $num-cols {\n                $devidedval: math.div($num-cols, $i);\n                $perc: unquote(math.div(100, $devidedval) + \"%\");\n                @include grid-classes(\"m\", $i, $perc);\n                $i: $i + 1;\n            }\n        }\n\n        @media #{$large-and-up} {\n            $i: 1;\n            @while $i <= $num-cols {\n                $devidedval: math.div($num-cols, $i);\n                $perc: unquote(math.div(100, $devidedval) + \"%\");\n                &.l#{$i} {\n                    width: $perc;\n                    @include reset-offset;\n                }\n                $i: $i + 1;\n            }\n\n            $i: 1;\n            @while $i <= $num-cols {\n                $devidedval: math.div($num-cols, $i);\n                $perc: unquote(math.div(100, $devidedval) + \"%\");\n                @include grid-classes(\"l\", $i, $perc);\n                $i: $i + 1;\n            }\n        }\n\n        @media #{$extra-large-and-up} {\n            $i: 1;\n            @while $i <= $num-cols {\n                $devidedval: math.div($num-cols, $i);\n                $perc: unquote(math.div(100, $devidedval) + \"%\");\n                &.xl#{$i} {\n                    width: $perc;\n                    @include reset-offset;\n                }\n                $i: $i + 1;\n            }\n\n            $i: 1;\n            @while $i <= $num-cols {\n                $devidedval: math.div($num-cols, $i);\n                $perc: unquote(math.div(100, $devidedval) + \"%\");\n                @include grid-classes(\"xl\", $i, $perc);\n                $i: $i + 1;\n            }\n        }\n    }\n}\n","// Import Philips Lighting colors\n@import \"../../../assets/sass/_colors.scss\";\n@import \"../../../assets/sass/core.scss\";\n\nfooter {\n    height: 100px;\n    background-color: primary-palette(100-white);\n    text-align: center;\n\n    span {\n        color: primary-palette(100-dark-gray);\n        font-size: 14px;\n    }\n\n    a {\n        text-decoration: none;\n    }\n\n    li {\n        display: inline-block;\n        padding-right: 10px;\n\n        &:first-child {\n            span {\n                border-left-style: none;\n            }\n        }\n\n        span {\n            color: primary-palette(100-dark-gray);\n            border-left-color: base-color(20-dark-gray);\n            border-left-style: solid;\n            border-left-width: 1px;\n            padding-left: 5px;\n            line-height: 15px;\n        }\n        a {\n            text-decoration: none;\n        }\n    }\n}","﻿@import '_colors';\n@import '_variables.scss';\n@import '_grid';\n@import url('https://fonts.googleapis.com/css?family=Roboto:400,500,700');\n\nhtml {\n    font-family: 'Roboto', sans-serif;\n    font-size: 15px;\n}\n\nhtml, body {\n    min-height: 100vh;\n    margin: 0px;\n}\n\n/* Weird ng-component fix */ \nng-component {\n    width: 100%;\n    background-color: primary-palette(100-white);\n}\n\n/* iFrame fix for adal iframe */\niframe{ \n    border: 0!important;\n}\n\n.fill-remaining-space {\n    flex: 1 1 auto;\n}\n\n@for $i from 1 through 8 {\n    .flex-#{$i} {\n        flex: $i!important;\n    }\n}\n\n@for $i from 1 through 4 {\n    $x: #{$i * 25};\n    .w-#{$x} {\n        width: unquote($x + \"% \" + !important);\n    }\n    .h-#{$x} {\n        height: unquote($x + \"% \" + !important);\n    }\n}\n\n@for $i from 0 through 10 {\n    $x: #{$i * 5}px!important;\n\n    .mt-#{$i * 5} {\n        margin-top: $x\n    }\n\n    .mb-#{$i * 5} {\n        margin-bottom: $x\n    }\n\n    .mr-#{$i * 5} {\n        margin-right: $x\n    }\n\n    .ml-#{$i * 5} {\n        margin-left: $x\n    }\n\n    .m-#{$i * 5} {\n        margin: $x\n    }\n\n    .pt-#{$i * 5} {\n        padding-top: $x\n    }\n\n    .pb-#{$i * 5} {\n        padding-bottom: $x\n    }\n\n    .pr-#{$i * 5} {\n        padding-right: $x\n    }\n\n    .pl-#{$i * 5} {\n        padding-left: $x\n    }\n\n    .p-#{$i * 5} {\n        padding: $x\n    }\n}\n\n/*******************\n  Utility Classes\n*******************/\n\n.border-box{\n    box-sizing: border-box;\n}\n\n.center, .center-align {\n    text-align: center;\n}\n\n.text-right {\n    text-align: right;\n}\n\n.left {\n    float: left !important;\n}\n\n.right {\n    float: right !important;\n}\n\n.pointer {\n    cursor: pointer;\n}\n\n.position-inherit{\n    position: inherit!important;\n}\n\n.min-height-inherit{\n    min-height: inherit!important;\n}\n\n.hover:hover{\n    background-color: primary-palette(100-dark-gray);\n}\n\n.space-between{\n    justify-content: space-between;\n}\n\n.block {\n    display: block;\n}\n\n.flex {\n    display: flex;\n}\n\n.flex-center{\n    justify-content: center;\n    align-items: center;\n}\n\n.flex-column { \n    flex-direction: column;\n}\n\n.noselect {\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n/*******************\n  Custom Classes\n*******************/\n\n// The MDC-based dialog moved the legacy container padding onto mat-dialog-content, which this app doesn't use.\n.mat-mdc-dialog-container {\n    --mat-dialog-container-shape: 4px;\n\n    .mat-mdc-dialog-surface {\n        display: block;\n        box-sizing: border-box;\n        padding: 24px;\n        overflow: auto;\n    }\n}\n\n// The MDC-based chips are restyled here to keep the legacy (pre-MDC) look.\n.mat-mdc-chip {\n    --mat-chip-container-height: 27px;\n    --mat-chip-container-shape-radius: 0;\n    --mat-chip-outline-width: 0;\n    --mat-chip-label-text-size: 14px;\n    --mat-chip-label-text-weight: 500;\n    display: inline-flex;\n    vertical-align: middle;\n    padding: 0;\n\n    // The action's horizontal padding has no token, and it lives in MatChip's own template.\n    .mdc-evolution-chip__action {\n        padding: 0 5px;\n    }\n}\n\n.mat-chip-active,\n.mat-chip-inactive {\n    --mat-chip-label-text-color: #{primary-palette(100-white)};\n    --mat-chip-selected-label-text-color: #{primary-palette(100-white)};\n}\n\n.mat-chip-active {\n    --mat-chip-elevated-container-color: #{signal-color-palette(100-green)};\n    --mat-chip-elevated-selected-container-color: #{signal-color-palette(100-green)};\n    background-color: signal-color-palette(100-green)!important;\n}\n\n.mat-chip-inactive {\n    --mat-chip-elevated-container-color: #{primary-palette(100-coral)};\n    --mat-chip-elevated-selected-container-color: #{primary-palette(100-coral)};\n    background-color: primary-palette(100-coral)!important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
